import { ITrackingAction } from '../tracking/tracking.data';

export const REPORTS_DASHBOARD_ROUTE = 'dashboard';
export const REPORTS_TYPE_ROUTE = 'type';
export const EXPORT_CSV = 'CSV';
export const EXPORT_PDF = 'PDF';
export const PDF_LIMIT_ERROR_CODE = 10000;
export const HOME_METRICS_POLLING_INTERVAL = 1000 * 60 * 10; // 10 minutes
export const SALES_JOURNAL = 'sales_journal'; // sales_journal report type

export enum ReportExportFormatEnum {
  CSV = 'csv',
  PDF = 'pdf',
}

export interface IReportExportAction {
  label: string;
  reportFormat: ReportExportFormatEnum;
  trackingAction?: ITrackingAction;
}

export enum ReportExpandedViewTypesEnum {
  overdue = 'overdue',
  unpaid = 'unpaid',
  unsent = 'unsent',
  tax_year_monthly = 'tax_year_monthly',
  tax_year_quarterly = 'tax_year_quarterly',
  pending_estimates = 'pending_estimates',
}
